// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__kSY4R","notes":"Notes_notes__2NjE9"};